import { render, staticRenderFns } from "./documentacion.vue?vue&type=template&id=0e4c83ce"
import script from "./documentacion.vue?vue&type=script&lang=js"
export * from "./documentacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports